import { MenuItemApiModel } from '@cxb/content-stb-api';
import { MenuApiModel } from '@cxb/content-stb-api/model/menuApiModel';
import { Entity } from '@nx-data/nx-data';

export class MenuEntity extends Entity implements MenuApiModel {
  public landingPageSlug: string;
  public menuItems: Array<MenuItemApiModel>;
}
